import type { IContextList } from './context-list.types'
import { ContextListView } from './context-list.view'

export function ContextList({ ...contextManager }: IContextList) {
  return <ContextListView {...contextManager} />
}
